(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2222],{

/***/ 22222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_home_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.js + 1 modules
var use_viewport_scroll = __webpack_require__(8274);
// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/value/use-transform.js + 4 modules
var use_transform = __webpack_require__(93976);
// EXTERNAL MODULE: ../packages/ab-home/src/ab-home.scss
var ab_home = __webpack_require__(81328);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(85556);
// EXTERNAL MODULE: ../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(76065);
// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/render/utils/animation.js
var animation = __webpack_require__(4190);
// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/render/utils/setters.js + 2 modules
var setters = __webpack_require__(68593);
;// CONCATENATED MODULE: ../node_modules/framer-motion/dist/es/animation/animation-controls.js




/**
 * @public
 */ function animationControls() {
    /**
     * Track whether the host component has mounted.
     */ var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */ var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */ var subscribers = new Set();
    var controls = {
        subscribe: function subscribe(visualElement) {
            subscribers.add(visualElement);
            return function() {
                return void subscribers.delete(visualElement);
            };
        },
        start: function start(definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */ if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function(visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride
                    }));
                });
                return Promise.all(animations_1);
            } else {
                return new Promise(function(resolve) {
                    pendingAnimations.push({
                        animation: [
                            definition,
                            transitionOverride
                        ],
                        resolve: resolve
                    });
                });
            }
        },
        set: function set(definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function(visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function stop() {
            subscribers.forEach(function(visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function mount() {
            hasMounted = true;
            pendingAnimations.forEach(function(_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation))).then(resolve);
            });
            return function() {
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}


// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(34459);
;// CONCATENATED MODULE: ../node_modules/framer-motion/dist/es/animation/use-animation.js



/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * @library
 *
 * ```jsx
 * import * as React from 'react'
 * import { Frame, useAnimation } from 'framer'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <Frame animate={controls} />
 * }
 * ```
 *
 * @motion
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}


// EXTERNAL MODULE: ../node_modules/framer-motion/dist/es/render/dom/motion.js + 95 modules
var motion = __webpack_require__(74212);
// EXTERNAL MODULE: ../node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(28447);
;// CONCATENATED MODULE: ../packages/ab-home/src/Image.tsx




var MovingImage = function(param) {
    var yPosAnim = param.yPosAnim, image = param.image, imageMob = param.imageMob, className = param.className;
    var myRef = (0,react.useRef)();
    var animation = useAnimation();
    var ref = (0,es/* useInViewport */.NM)(myRef, {}, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: true
    }), inViewport = ref.inViewport, enterCount = ref.enterCount, leaveCount = ref.leaveCount;
    (0,react.useEffect)(function() {
        if (inViewport) {
            animation.start("visible");
        } else {
            animation.start("hidden");
        }
    }, [
        inViewport
    ]);
    var variants = {
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 1
            }
        },
        hidden: {
            opacity: 0,
            scale: 0.8
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.picture */.E.picture, {
        className: className,
        style: {
            y: yPosAnim
        },
        animate: animation,
        initial: "hidden",
        variants: variants,
        ref: myRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: imageMob === null || imageMob === void 0 ? void 0 : imageMob.mediaItemUrl,
                media: "(max-width: 850px)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image === null || image === void 0 ? void 0 : image.mediaItemUrl
            })
        ]
    });
};
/* harmony default export */ var Image = (MovingImage);

;// CONCATENATED MODULE: ../packages/ab-home/src/index.tsx






var Home = function(param) {
    var title = param.title, _text = param.text, text = _text === void 0 ? [] : _text, titulo = param.titulo, contenido = param.contenido, imagenes = param.imagenes, imgmob = param.imgmob;
    var scrollYProgress = (0,use_viewport_scroll/* useViewportScroll */.M)().scrollYProgress;
    // console.log("Home ", scrollYProgress);
    var opacity = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.1,
        0.2
    ], [
        0,
        0.5,
        1
    ]);
    var yPosAnim = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.4
    ], [
        0,
        -150,
        -250
    ]);
    var opacity2 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.15,
        0.25
    ], [
        0,
        0.5,
        1
    ]);
    var yPosAnim2 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.4
    ], [
        0,
        -200,
        -300
    ]);
    var opacity3 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.3
    ], [
        0,
        0.5,
        1
    ]);
    var yPosAnim3 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.4
    ], [
        0,
        -250,
        -350
    ]);
    var opacity4 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.25,
        0.35
    ], [
        0,
        0.5,
        1
    ]);
    var yPosAnim4 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.4
    ], [
        0,
        -300,
        -400
    ]);
    var opacity5 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.3,
        0.35
    ], [
        0,
        0.5,
        1
    ]);
    var yPosAnim5 = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.2,
        0.4
    ], [
        0,
        -350,
        -450
    ]);
    // console.log("Home", scrollYProgress);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-home",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "h2",
                children: title || titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                text: text,
                content: contenido,
                singleColumn: true,
                noPlus: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "spa",
                yPosAnim: yPosAnim2,
                image: imagenes === null || imagenes === void 0 ? void 0 : imagenes[0],
                imageMob: imgmob === null || imgmob === void 0 ? void 0 : imgmob[1]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "mayordomo",
                yPosAnim: yPosAnim,
                image: imagenes === null || imagenes === void 0 ? void 0 : imagenes[1],
                imageMob: imgmob === null || imgmob === void 0 ? void 0 : imgmob[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "bodega",
                yPosAnim: yPosAnim3,
                image: imagenes === null || imagenes === void 0 ? void 0 : imagenes[2],
                imageMob: imgmob === null || imgmob === void 0 ? void 0 : imgmob[2]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "refectorio",
                yPosAnim: yPosAnim5,
                image: imagenes === null || imagenes === void 0 ? void 0 : imagenes[3],
                imageMob: imgmob === null || imgmob === void 0 ? void 0 : imgmob[3]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "vinedos",
                yPosAnim: yPosAnim4,
                image: imagenes === null || imagenes === void 0 ? void 0 : imagenes[4],
                imageMob: imgmob === null || imgmob === void 0 ? void 0 : imgmob[3]
            })
        ]
    });
};
/* harmony default export */ var ab_home_src = (Home);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 81328:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);